import React from "react";
import { Box, Paper, Typography, Stack } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { BRAND } from "../../theme";

const PlaceholderPage: React.FC<{ title: string; blurb: string }> = ({ title, blurb }) => (
  <Box>
    <Typography variant="h4" sx={{ mb: 2 }}>{title}</Typography>
    <Paper variant="outlined" sx={{ p: 5, textAlign: "center" }}>
      <Stack spacing={1.5} alignItems="center">
        <Box sx={{ bgcolor: BRAND.greenSoft, color: BRAND.green, width: 56, height: 56, borderRadius: 2, display: "grid", placeItems: "center" }}>
          <ConstructionIcon fontSize="large" />
        </Box>
        <Typography variant="h6">Planned for a future sprint</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 440 }}>{blurb}</Typography>
      </Stack>
    </Paper>
  </Box>
);
export default PlaceholderPage;
